export enum OtherLoginType {
  Google = 'google',
  Apple = 'apple'
}

export interface OtherItem {
  type: OtherLoginType
  icon: string
  text: string
}